<template>
    <div class="home-main">
        <div class="ms-doc">
            <el-row>
                <el-col>
                    <div class="title">
                        <div class="left">
                            <span class="icon"></span>
                            <span>预约统计</span>
                        </div>
                        <div class="right">
                            <div class="date">
                                <el-date-picker
                                    v-model="timeS"
                                    type="date"
                                    placeholder="选择开始日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                                <span>-</span>
                                <el-date-picker
                                    v-model="timeE"
                                    type="date"
                                    placeholder="选择结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </div>
                            <div class="Company">
                                <el-select v-model="company_id" placeholder="请选择" v-loadmore="loadPartner" :loading="companyloading" remote :remote-method="remoteMethod" filterable>
                                    <el-option
                                        label="全部公司"
                                        value="">
                                    </el-option>
                                    <el-option
                                        v-for="item in companyData"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <el-button icon="el-icon-search" type="primary" plain @click="search">
                                搜索
                            </el-button>
                        </div>
                    </div>
                    <div class="main">
                        <div class="echarts-order" ref="echarts-order"></div>
                        <el-row>
                            <el-col :span="10">
                                <el-table :data="SelectTable(OrderData)" border :height="250">
                                    <el-table-column prop="company_name" label="公司名">
                                    </el-table-column>
                                    <el-table-column prop="space_title" label="场地名">
                                    </el-table-column>
                                    <el-table-column prop="frequency" label="次数">
                                    </el-table-column>
                                </el-table>
                            </el-col>
                            <el-col :span="12" :offset="2">
                                <el-table :data="OrderDatass" border :height="250">
                                    <el-table-column min-width="180px" prop="company_name" label="公司名">
                                    </el-table-column>
                                    <el-table-column min-width="180px" prop="space_title" label="场地名">
                                    </el-table-column>
                                    <el-table-column prop="user_name" label="预定人">
                                    </el-table-column>
                                    <el-table-column prop="hours" label="时长">
                                    </el-table-column>
                                    <el-table-column prop="date" label="预定日期">
                                    </el-table-column>
                                    <el-table-column prop="time" label="预定时间段">
                                    </el-table-column>
                                </el-table>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { getToken, getAdminId } from "../../utils/auth";
import time from "../../utils/time";
export default {
    data() {
        return {
            company_id: "",
            room: "",
            timeS: "",
            timeE: "",
            companyData: [],
            keyword: "",
            Size: 100,
            currentPage: 1,
            companyloading: false,
            OrderData: [],
            space: [],
            companyName: [],
            OrderDatas: [],
            OrderDatass: []
        };
    },
    mounted() {},
    methods: {
        SelectTable(data) {
            let datas = [];
            for (let item in data) {
                if (data[item].frequency !== 0) {
                    datas.push(JSON.parse(JSON.stringify(data[item])));
                }
            }
            return datas;
        },
        search() {
            let that = this;
            that.OrderShow().then(res => {
                console.log(res);
                if (that.company_id !== "") {
                    that.echartsorderShow("bar");
                } else {
                    that.echartsorderShow();
                }
            });
        },
        echartsorderShow(type = "line") {
            // let that = this;
            var chartDom = this.$refs["echarts-order"];
            this.$echarts.dispose(chartDom);
            var myChart = this.$echarts.init(chartDom);
            console.log(this.OrderData);
            let data = JSON.parse(JSON.stringify([]));
            let datas = [];
            for (let item in this.OrderData) {
                datas[this.OrderData[item].space_id] = [];
            }
            for (let item in this.OrderData) {
                datas[this.OrderData[item].space_id].push(
                    JSON.parse(JSON.stringify(this.OrderData[item]))
                );
            }
            for (let item in datas) {
                let obj = {
                    name: datas[item][0].space_title,
                    type: type,
                    data: []
                };
                if (type === "line") {
                    obj.stack = "Total";
                } else {
                    obj.barWidth = "10%";
                }
                for (let items in this.companyName) {
                    for (let itemss in datas[item]) {
                        if (
                            this.companyName[items] ===
                            datas[item][itemss].company_name
                        ) {
                            obj.data.push(
                                JSON.parse(
                                    JSON.stringify(datas[item][itemss].hours)
                                )
                            );
                        }
                    }
                }
                data.push(JSON.parse(JSON.stringify(obj)));
            }
            console.log(data);
            let option = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.space
                },
                grid: {
                    left: "6%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    // nameTextStyle: {
                    //     width: 50
                    // },
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        interval: 0,
                        // rotate: 45,
                        formatter: function(value) {
                            // let str = that.spl(value, 3);
                            // return str.join("\n");
                            var maxLength = 5;
                            // 每项显示文字个数
                            if (value.length > maxLength) {
                                // 如果文字大于3,
                                value = value.slice(0, 5) + "...";
                                return value;
                            } else {
                                return value;
                            }
                        }
                        // width: 50,
                        // overflow: "breakAll"
                    },
                    data: this.companyName
                },
                yAxis: {
                    type: "value",
                    name: "小时"
                },
                series: data
            };
            option && myChart.setOption(option);
        },
        spl(source, count) {
            let arr = [];
            for (let i = 0, len = source.length / count; i < len; i++) {
                let subStr = source.substr(0, count);
                arr.push(subStr);
                source = source.replace(subStr, "");
            }
            return arr;
        },
        OrderShow() {
            let that = this;
            return new Promise(resolve => {
                let data = {
                    timeS: that.timeS,
                    timeE: that.timeE,
                    // space_id: that.space_id,
                    // limit: that.Size,
                    // page: that.currentPage,
                    company_id: that.company_id,
                    room: that.room,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken(),
                    IsHome: 1
                };
                this.$store
                    .dispatch("BookingManagementListShow", data)
                    .then(res => {
                        res.data.forEach(row => {
                            row.times = JSON.parse(row.times);
                            row.time =
                                time.time[row.times[0]].label +
                                "~" +
                                time.time[row.times[row.times.length - 1]].end;
                        });
                        let OrderData = res.data;
                        let OrderDatas = {};
                        let companyName = [];
                        let space = [];
                        let spaces = [];
                        let spaceName = [];
                        for (let item in OrderData) {
                            if (
                                companyName.indexOf(
                                    OrderData[item].company_name
                                ) === -1
                            ) {
                                companyName.push(
                                    JSON.parse(
                                        JSON.stringify(
                                            OrderData[item].company_name
                                        )
                                    )
                                );
                            }
                        }
                        that.companyName = JSON.parse(
                            JSON.stringify(companyName)
                        );
                        for (let item in OrderData) {
                            if (
                                space.indexOf(OrderData[item].space_id) === -1
                            ) {
                                space.push(
                                    JSON.parse(
                                        JSON.stringify(OrderData[item].space_id)
                                    )
                                );
                                spaceName.push(
                                    JSON.parse(
                                        JSON.stringify(
                                            OrderData[item].space_title
                                        )
                                    )
                                );
                                spaces.push(
                                    JSON.parse(
                                        JSON.stringify({
                                            space_title: JSON.parse(
                                                JSON.stringify(
                                                    OrderData[item].space_title
                                                )
                                            ),
                                            space_id: JSON.parse(
                                                JSON.stringify(
                                                    OrderData[item].space_id
                                                )
                                            )
                                        })
                                    )
                                );
                            }
                        }
                        that.space = JSON.parse(JSON.stringify(spaceName));
                        for (let item in space) {
                            OrderDatas[space[item]] = {};
                            for (let items in companyName) {
                                OrderDatas[space[item]][
                                    companyName[items]
                                ] = [];
                            }
                        }
                        for (let item in OrderData) {
                            OrderDatas[OrderData[item].space_id][
                                OrderData[item].company_name
                            ].push(JSON.parse(JSON.stringify(OrderData[item])));
                        }
                        // console.log(OrderDatas);
                        that.OrderDatas = JSON.parse(
                            JSON.stringify(OrderDatas)
                        );
                        let OrderDatass = [];
                        for (let item in OrderDatas) {
                            for (let items in OrderDatas[item]) {
                                let obj = {
                                    space_id: item,
                                    hours: 0,
                                    frequency: 0
                                };
                                obj.company_name = items;
                                for (let itemss in OrderDatas[item][items]) {
                                    obj.space_title =
                                        OrderDatas[item][items][
                                            itemss
                                        ].space_title;
                                    // console.log(obj);
                                    obj.hours += Number(
                                        OrderDatas[item][items][itemss].hours
                                    );
                                    obj.frequency += 1;
                                }
                                OrderDatass.push(
                                    JSON.parse(JSON.stringify(obj))
                                );
                            }
                        }
                        for (let item in OrderDatass) {
                            if (!OrderDatass[item].space_title) {
                                for (let items in spaces) {
                                    if (
                                        Number(OrderDatass[item].space_id) ===
                                        Number(spaces[items].space_id)
                                    ) {
                                        OrderDatass[
                                            item
                                        ].space_title = JSON.parse(
                                            JSON.stringify(
                                                spaces[items].space_title
                                            )
                                        );
                                    }
                                }
                            }
                        }
                        that.OrderDatass = OrderData;
                        that.OrderData = OrderDatass;
                        resolve(OrderDatass);
                    });
            });
        },
        remoteMethod(query) {
            if (query !== "") {
                this.companyloading = true;
                this.companyData = [];
                this.keyword = query;
                this.GetCompanyList(query);
            } else {
                this.companyloading = true;
                this.keyword = "";
                this.companyData = [];
                this.GetCompanyList();
            }
        },
        // 分页下拉加载
        loadPartner() {
            this.pages += 1;
            this.GetCompanyList(this.keyword);
        },
        GetCompanyList(keyword) {
            let that = this;
            return new Promise(resolve => {
                let data = {
                    keyword: keyword,
                    room: "",
                    limit: this.Size,
                    page: this.currentPage,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken()
                };
                this.$store.dispatch("CompanyListShow", data).then(res => {
                    that.companyloading = false;
                    that.companyData = res.data;
                    resolve();
                });
            });
        }
    },
    watch: {},
    created() {
        let that = this;
        let date = new Date();
        let Y = date.getFullYear();
        date.setDate(1);
        let M = date.getMonth() + 1;
        let D = new Date().getDate();
        if (M < 10) {
            M = "0" + M;
        }
        if (D < 10) {
            D = "0" + D;
        }
        this.timeS = Y + "-" + M + "-" + "01";
        this.timeE = Y + "-" + M + "-" + D;
        this.GetCompanyList(this.keyword).then(() => {
            that.OrderShow().then(res => {
                console.log(res);
                that.echartsorderShow();
            });
        });
    }
};
</script>

<style>
.home-main {
    /* height: 100%; */
    padding: 10px;
}
.ms-doc {
    width: 100%;
    /* max-width: 980px; */
    font-family: PingFang SC, Helvetica Neue, Arial, sans-serif;
    color: #2d2f33;
    /* background-color: #cccccc; */
}
.ms-doc .el-row .el-col {
    background-color: #fff;
}
.ms-doc .el-row .el-col .title {
    height: 40px;
    line-height: 40px;
    padding: 0px 10px 0px 20px;
}
.ms-doc .el-row .el-col .title .left {
    float: left;
}
.ms-doc .el-row .el-col .title .right {
    float: right;
}
.ms-doc .el-row .el-col .title .right > div {
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
}
.ms-doc .el-row .el-col .title .right > .el-button {
    padding: 7px 15px;
    font-size: 12px;
    margin-left: 5px;
}
.ms-doc .el-row .el-col .title .right .date .el-date-editor {
    height: 30px;
    line-height: 30px;
    width: 140px;
    font-size: 12px;
}
.ms-doc .el-row .el-col .title .right .date > span {
    margin-left: 5px;
    margin-right: 5px;
    color: #999;
}
.ms-doc .el-row .el-col .title .right .Company .el-select {
    width: 150px;
}
.ms-doc .el-row .el-col .title .right .Company .el-select .el-input {
    font-size: 12px;
}
.ms-doc .el-row .el-col .title .right .date .el-date-editor .el-input__inner,
.ms-doc .el-row .el-col .title .right .date .el-date-editor .el-input__prefix,
.ms-doc .el-row .el-col .title .right .date .el-date-editor .el-input__suffix,
.ms-doc .el-row .el-col .title .right .date .el-date-editor .el-input__icon,
.ms-doc .el-row .el-col .title .right .Company .el-select,
.ms-doc .el-row .el-col .title .right .Company .el-select .el-input,
.ms-doc .el-row .el-col .title .right .Company .el-select .el-input input,
.ms-doc .el-row .el-col .title .right .Company .el-select .el-input__suffix,
.ms-doc .el-row .el-col .title .right .Company .el-select .el-input__icon {
    height: 30px;
    line-height: 30px;
}
.ms-doc .el-row .el-col .title .left .icon {
    background: #3f82fe;
    display: inline-block;
    width: 5px;
    height: 16px;
    vertical-align: top;
    margin-right: 10px;
    margin-top: 11px;
}
.ms-doc .el-row .el-col .title .left > span {
    color: #666666;
}
.ms-doc .el-row .el-col .main {
    padding: 0px 20px;
}
.ms-doc .el-row .el-col .main .el-table {
    margin: 10px 0 20px;
}
.ms-doc .el-row .el-col .echarts-order {
    width: 100%;
    height: 400px;
}
</style>
